import * as Yup from "yup";

export const CourseSchema = Yup.object()
  .shape({
    courseName: Yup.string().required("Please enter a course name"),
    courseCode: Yup.string().required("Please enter a course code"),
    level: Yup.string().required("Please choose a level"),
    fieldOfStudy: Yup.array()
      .of(Yup.string())
      .min(1, "At least one field of study is required"),
    modeOfStudy: Yup.array()
      .of(Yup.string())
      .min(1, "At least one mode of study is required"),
    startDates: Yup.array()
      .of(Yup.string())
      .min(1, "At least one start date is required"),
    durationYears: Yup.number()
      .min(0, "Cannot be negative")
      .integer("Must be a whole number"),
    durationMonths: Yup.number()
      .min(0, "Cannot be negative")
      .integer("Must be a whole number"),
    durationWeeks: Yup.number()
      .min(0, "Cannot be negative")
      .integer("Must be a whole number"),
    durationDays: Yup.number()
      .min(0, "Cannot be negative")
      .integer("Must be a whole number"),
    estimatedTotalCourseFee: Yup.number()
      .integer("Fees per year must be a whole number")
      .positive("Please enter a positive number")
      .required("Please enter fees per year"),
    institutionName: Yup.string().required("Please enter an institution name"),
    country: Yup.string().required("Please choose a country"),
  })
  .test("at-least-one-duration", "Duration must be provided", (values) => {
    const { durationYears, durationMonths, durationWeeks, durationDays } =
      values;
    return (
      Number(durationYears) > 0 ||
      Number(durationMonths) > 0 ||
      Number(durationWeeks) > 0 ||
      Number(durationDays) > 0
    );
  });
